import { render, staticRenderFns } from "./TimeLineSmall.vue?vue&type=template&id=28ca1a54&scoped=true"
import script from "./TimeLineSmall.vue?vue&type=script&lang=js"
export * from "./TimeLineSmall.vue?vue&type=script&lang=js"
import style0 from "./TimeLineSmall.vue?vue&type=style&index=0&id=28ca1a54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ca1a54",
  null
  
)

export default component.exports